import { useState } from 'react';
import PropTypes from 'prop-types';
import CheckboxMui from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const Checkbox = ({
  disabled = false,
  fontSize = 28,
  defaultChecked = false,
  label = '',
  handleValueChange = (_value) => {},
}) => {
  const [value, setValue] = useState(defaultChecked);
  const handleChange = (e) => {
    setValue(e.target.checked);
    handleValueChange(e.target.checked);
  };

  return (
    <div>
      <FormControlLabel
        disabled={disabled}
        onChange={handleChange}
        control={
          <CheckboxMui
            disabled={disabled}
            defaultChecked={defaultChecked}
            value={value}
            sx={{
              '& .MuiSvgIcon-root': { fontSize },
              '&.Mui-checked': {
                color: 'black',
              },
            }}
          />
        }
        label={label}
      />
    </div>
  );
};

// Prop validation
Checkbox.propTypes = {
  disabled: PropTypes.bool,
  fontSize: PropTypes.number,
  defaultChecked: PropTypes.bool,
  label: PropTypes.string,
  handleValueChange: PropTypes.func,
};

export default Checkbox;
